import { Badge, Group, Text } from '@mantine/core';

// Renders an "old -> new" value pair for batch-edit preview tables.
// When the value is unchanged (or there is no previous value) only the new
// value badge is shown.
const ChangeCell = ({ oldVal, newVal, oldColor, newColor = 'teal' }) => {
    const changed = oldVal && oldVal !== newVal;

    return (
        <Group spacing={6} noWrap sx={{ whiteSpace: 'nowrap' }}>
            {changed ? (
                <Badge color={oldColor || 'gray'} variant='outline' sx={{ textTransform: 'none', textDecoration: 'line-through', opacity: 0.6 }}>
                    {oldVal}
                </Badge>
            ) : null}
            {changed ? (
                <Text size='xs' color='dimmed'>
                    →
                </Text>
            ) : null}
            <Badge color={newColor} variant='light' sx={{ textTransform: 'none' }}>
                {newVal}
            </Badge>
        </Group>
    );
};

export default ChangeCell;
